import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { rpc } from "./rpc";

/**
 * Hook estándar para consumir un RPC api_*.
 * A diferencia de la app actual (que ante un fallo deja datos viejos en
 * silencio), aquí el estado de error viaja hasta la vista para pintarse.
 */
export function useRpc<T>(
  fn: string,
  params: Record<string, unknown> = {},
  opciones: { enabled?: boolean } = {},
): UseQueryResult<T, Error> {
  return useQuery<T, Error>({
    queryKey: [fn, params],
    queryFn: () => rpc<T>(fn, params),
    enabled: opciones.enabled ?? true,
    staleTime: 60_000,
    retry: 1,
  });
}
